import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { stripLanguage } from "../../i18n/languages";

// Jump to the top when the page changes, but stay in place when only the
// language changes (/about -> /fr/about)
function ScrollToTop() {
  const { pathname } = useLocation();
  const previousPage = useRef(stripLanguage(pathname));

  useEffect(() => {
    const page = stripLanguage(pathname);
    if (page !== previousPage.current) window.scrollTo(0, 0);
    previousPage.current = page;
  }, [pathname]);

  return null;
}

export default ScrollToTop;
